// extracted by mini-css-extract-plugin
export default {"page":"tX-z","cartModal":"uX-z","checkout":"vX-z","placeholder":"wX-z","account":"xX-z"};